module.exports = __webpack_public_path__ + "static/media/0ebd7648-5847-404a-a88a-28a353c0921c.f253a48e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/0ebd7648-5847-404a-a88a-28a353c0921c.eot
// module id = 88
// module chunks = 0